// в классическом дизайне filled-кнопки нет — используются существующие кнопки по цвету
import { GrayButton, GreenButton, RedButton } from '../oval-button/oval-button.classic';

const BUTTONS = { default: GrayButton, success: GreenButton, danger: RedButton };

export const FilledButton = ({ color = 'default', ...rest }) => {
  const Component = BUTTONS[color] ?? GrayButton;
  return <Component {...rest} />;
};
